import React, {Component} from 'react';
import EnergyItem from '../EnergyItem/EnergyItem';
import {GridList, GridCell} from 'rmwc/GridList';
import {List} from 'rmwc/List'

//<h1>Total daily energy: {this.props.totalDailyEnergy}</h1>

export default class EnergyList extends Component {
  render(){
    return(
      <GridList>

        {this.props.items.map((item, index) => {
          return(
            <EnergyItem
              key={index}
              item={item}
              index={index}
              removeItem={this.props.removeItem} markEnergyInactive={this.props.markEnergyInactive}
            />
          )
        })
      }
    </GridList>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EnergyList/EnergyList.js